import {
    UPDATE_LISTINGS_UGC,
    FETCH_UGC,
    TOGGLE_UGC_VIEW
} from '../../actions/ugc';

const ugcReducer = (ugcMap = {}) => {

    const initialState = {
        ugcMap,
        showOriginal: true
    };

    return (state = initialState, action = {}) => {
        const { type, data } = action;

        switch (type) {
            case UPDATE_LISTINGS_UGC:
                return {
                    ...state,
                    ugcMap: {
                        ...state.ugcMap,
                        original: addListingsUGC({
                            original: state.ugcMap.original,
                            listingsUGC: data.listingsUGC,
                            carouselType: data.carouselType
                        })
                    }
                };
            case TOGGLE_UGC_VIEW:
                return {
                    ...state,
                    showOriginal: !state.showOriginal
                };
            case FETCH_UGC:
                return {
                    showOriginal: data.shouldToggle ? !data.translatedUGC : state.showOriginal,
                    ugcMap: {
                        ...state.ugcMap,
                        translated: data.translatedUGC
                    }
                };
            default:
                return state;
        }
    };
};

const addListingsUGC = ({ original, listingsUGC, carouselType }) => {
    const listings = { ...original.listings };
    listings[carouselType] = listingsUGC;

    return {
        ...original,
        listings
    };
};

export default ugcReducer;
